var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('fieldset',{class:_vm.$style.root},[_c('div',{class:_vm.$style.label},[_c('legend',{staticClass:"h4"},[_vm._v("\n      "+_vm._s(_vm.legend)+"\n    ")])]),_vm._v(" "),_c('div',{class:_vm.$style.fields},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }